// extracted by mini-css-extract-plugin
export default {"searchbar":"Searchbar_searchbar__0FWoU","form":"Searchbar_form__D-hp5","input":"Searchbar_input__19umw","searchBtn":"Searchbar_searchBtn__ljDiA"};